"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_2 = require("../../../../api/webAApi");
var BrandsContentListCtl = /** @class */ (function (_super) {
    __extends(BrandsContentListCtl, _super);
    function BrandsContentListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_br_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_br_identity = UIUtils_1.UIUtils.IProp2Str(function (o) { o.identity; });
        _this.dk_br_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_bd_name = UIUtils_1.UIUtils.IProp2Str(function (o) { o.dirName; });
        _this.dk_bf_filename = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fileName; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsContentListCtl.prototype.ResetData = function () {
        this.DATA = {
            brands: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    BrandsContentListCtl.prototype.getBrandItemById = function (id) {
        for (var i = 0; i < this.DATA.brands.length; i++) {
            if (this.DATA.brands[i].key === id) {
                return this.DATA.brands[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    BrandsContentListCtl.prototype.getDirectoryItemByName = function (brand, dirName) {
        for (var i = 0; i < brand.directories.length; i++) {
            if (brand.directories[i].dirName === dirName) {
                return brand.directories[i];
            }
        }
        throw "object with name [" + dirName + "] not found !";
    };
    BrandsContentListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListCmsBrandsContentDirectoryAllowedGet.exec({}, function (resp) {
            _this.DATA.brands = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.brands.length; i++) {
                var brandItem = {
                    key: resp.brands[i].key_uid,
                    identity: resp.brands[i].identity,
                    title: resp.brands[i].title,
                    directories: []
                };
                for (var j = 0; j < resp.brands[i].directories.length; j++) {
                    var dirItem = {
                        dirName: resp.brands[i].directories[j].name,
                        files: []
                    };
                    for (var k = 0; k < resp.brands[i].directories[j].files.length; k++) {
                        var fileItem = {
                            fileName: resp.brands[i].directories[j].files[k].filename
                        };
                        dirItem.files.push(fileItem);
                    }
                    brandItem.directories.push(dirItem);
                }
                _this.DATA.brands.push(brandItem);
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsContentListCtl.prototype.IsFileExists = function (brand, dir, fName, onDone) {
        var _this = this;
        webAApi_1.DoCmsBrandContentFileExists.exec({
            brand_id: brand.key,
            dir_name: dir.dirName,
            file_name: fName
        }, function (resp) {
            if (onDone) {
                onDone(resp.is_exists);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsContentListCtl.prototype.CreateDirectory = function (brand, dirName, onDone) {
        var _this = this;
        webAApi_1.DoCmsBrandContentDirectoryCreate.exec({
            brand_id: brand.key,
            dir_name: dirName
        }, function (resp) {
            brand.directories.push({
                dirName: dirName,
                files: [],
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsContentListCtl.prototype.RenameDirectory = function (brand, oldDirName, newDirName, onDone) {
        var _this = this;
        webAApi_1.DoCmsBrandContentDirectoryRename.exec({
            brand_id: brand.key,
            dir_name: oldDirName,
            dir_new_name: newDirName
        }, function (resp) {
            for (var i = 0; i < brand.directories.length; i++) {
                if (brand.directories[i].dirName === oldDirName) {
                    brand.directories[i].dirName = newDirName;
                }
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsContentListCtl.prototype.DeleteDirectory = function (brand, dirName, onDone) {
        var _this = this;
        webAApi_1.DoCmsBrandContentDirectoryDelete.exec({
            brand_id: brand.key,
            dir_name: dirName
        }, function (resp) {
            _this.RemoveDirectoryItem(brand, dirName);
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsContentListCtl.prototype.RemoveDirectoryItem = function (brand, dirName) {
        var i_idx = -1;
        for (var i = 0; i < brand.directories.length; i++) {
            if (brand.directories[i].dirName === dirName) {
                i_idx = i;
            }
        }
        var rest = brand.directories.slice(i_idx + 1);
        brand.directories.length = i_idx;
        return brand.directories.push.apply(brand.directories, rest);
    };
    BrandsContentListCtl.prototype.UploadFileAll = function (brand, dir, fName, fBase64, onDone) {
        var _this = this;
        webAApi_1.DoCmsBrandContentFileUploadAll.exec({
            brand_id: brand.key,
            dir_name: dir.dirName,
            file_name: fName,
            data_base64: fBase64
        }, function (resp) {
            dir.files.push({ fileName: fName });
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsContentListCtl.prototype.DoCmsBrandContentFileUploadReset = function (brand, dir, fName, onDone) {
        var _this = this;
        webAApi_1.DoCmsBrandContentFileUploadReset.exec({
            brand_id: brand.key,
            dir_name: dir.dirName,
            file_name: fName
        }, function (resp) {
            dir.files.push({ fileName: fName });
            //  this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsContentListCtl.prototype.DoCmsBrandContentFileUploadAppend = function (brand, dir, fName, fBase64, onDone) {
        var _this = this;
        webAApi_2.DoCmsBrandContentFileUploadAppend.exec({
            brand_id: brand.key,
            dir_name: dir.dirName,
            file_name: fName,
            data_base64: fBase64
        }, function (resp) {
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsContentListCtl.prototype.RenameFile = function (brand, dir, oldFileName, newFileName, onDone) {
        var _this = this;
        webAApi_1.DoCmsBrandContentFileRename.exec({
            brand_id: brand.key,
            dir_name: dir.dirName,
            file_name: oldFileName,
            file_new_name: newFileName
        }, function (resp) {
            for (var i = 0; i < dir.files.length; i++) {
                if (dir.files[i].fileName === oldFileName) {
                    dir.files[i].fileName = newFileName;
                }
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsContentListCtl.prototype.RemoveFileItem = function (dir, fName) {
        var i_idx = -1;
        for (var i = 0; i < dir.files.length; i++) {
            if (dir.files[i].fileName === fName) {
                i_idx = i;
            }
        }
        var rest = dir.files.slice(i_idx + 1);
        dir.files.length = i_idx;
        return dir.files.push.apply(dir.files, rest);
    };
    BrandsContentListCtl.prototype.DeleteFile = function (brand, dir, fName, onDone) {
        var _this = this;
        webAApi_1.DoCmsBrandContentFileDelete.exec({
            brand_id: brand.key,
            dir_name: dir.dirName,
            file_name: fName
        }, function (resp) {
            _this.RemoveFileItem(dir, fName);
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return BrandsContentListCtl;
}(BaseController_1.BaseController));
exports.BrandsContentListCtl = BrandsContentListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_images/ctl/BrandsContentListCtl.ts
// module id = 941
// module chunks = 0